import { createAnimData, createFiRow, IFrameAnimData } from '../engine/anims'

export interface IMonsterAnims {
  w: IFrameAnimData
  e: IFrameAnimData
  n: IFrameAnimData
  s: IFrameAnimData
  wAttack: IFrameAnimData
  eAttack: IFrameAnimData
  nAttack: IFrameAnimData
  sAttack: IFrameAnimData
  dead: IFrameAnimData
}

const createMonsterAnims = (idx: number) => {
  let y = idx + 1
  let ma: IMonsterAnims = {
    s: createAnimData(createFiRow(2, y, 10, 2)),
    w: createAnimData(createFiRow(2, y, 12, 2)),
    e: createAnimData(createFiRow(2, y, 14, 2)),
    n: createAnimData(createFiRow(2, y, 16, 2)),
    sAttack: createAnimData(createFiRow(2, y, 1, 2)),
    wAttack: createAnimData(createFiRow(2, y, 3, 2)),
    eAttack: createAnimData(createFiRow(2, y, 5, 2)),
    nAttack: createAnimData(createFiRow(2, y, 7, 2)),
    dead: createAnimData(createFiRow(2, y, 9, 1)),
    // idleS:  createAnimData(createFiRow(2, idx, 16, 2)),
  }
  ma.eAttack.after = ma.e
  ma.wAttack.after = ma.w
  ma.nAttack.after = ma.n
  ma.sAttack.after = ma.s
  return ma
}
export const monsterAnims: IMonsterAnims[] = []
export const numMonsters = 29 + 6 + 2
export function createData() {
  for (let i = 0; i < numMonsters; i++) {
    let ma = createMonsterAnims(i)
    monsterAnims.push(ma)
  }
}
